<script lang="ts" setup>
import { ref, computed, toRefs } from "vue";

const props = withDefaults(defineProps<{ url: string; poster?: string; controls?: boolean; cover?: boolean }>(), { controls: true, cover: false });

const poster = toRefs(props).poster;

const type = ref("video");

if (props.url.includes("vimeo")) {
    type.value = "vimeo";
}
if (props.url.includes("youtu")) {
    type.value = "youtube";
}

const wrapper = ref(null);
const plyr = ref(null);
const playing = ref(false);

const handlePlay = () => {
    console.log("play");
    playing.value = true;
    //@ts-ignore
    if (wrapper.value.classList.contains("unsnapped")) {
        //@ts-ignore
        wrapper.value.classList.remove("snapped");
    }
};
const handlePause = () => {
    console.log("pause");

    playing.value = false;
    //@ts-ignore
    if (wrapper.value.classList.contains("unsnapped")) {
        //@ts-ignore
        wrapper.value.classList.add("snapped");
    }
};

const options = computed(() => {
    return { poster: poster?.value ?? null, controls: ["play-large", "play", "progress", "current-time", "mute", "volume", "fullscreen"] };
});

const isIphone = computed(() => {
    return (
        ["iPhone Simulator", "iPhone", "iPod"].includes(navigator.platform) ||
        // iPad on iOS 13 detection
        (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    );
});
</script>

<template>
    <div ref="wrapper" class="!h-[auto] lg:!h-[auto]">
        <iframe v-if="isIphone" :src="url" class="w-full min-h-[181px]" allowfullscreen allowtransparency allow="autoplay"></iframe>

        <div v-else :class="{ cover: cover, controls: playing }">
            <vue-plyr v-if="type === 'vimeo'" ref="plyr" @play="handlePlay" @pause="handlePause" :options="{ ...options, vimeo: { byline: false, portrait: false, title: false, speed: true, transparent: false } }">
                <div class="plyr__video-embed">
                    <iframe :src="`${url}?loop=false&amp;byline=false&amp;portrait=false&amp;title=false&amp;speed=true&amp;transparent=0&amp;gesture=media`" allowfullscreen allowtransparency allow="autoplay"></iframe>
                </div>
            </vue-plyr>

            <vue-plyr v-else-if="type === 'video'" ref="plyr" @play="handlePlay" @pause="handlePause" :options="options">
                <video playsinline :data-poster="poster">
                    <source size="1080" :src="url" type="video/mp4" />
                </video>
            </vue-plyr>

            <vue-plyr v-else-if="type === 'youtube'" @play="handlePlay" @pause="handlePause" :options="{ ...options, youtube: { noCookie: false, rel: 0, showinfo: 0, iv_load_policy: 3, modestbranding: 1 } }">
                <div class="plyr__video-embed" ref="plyr">
                    <iframe :src="url" allowfullscreen allowtransparency allow="autoplay"></iframe>
                </div>
            </vue-plyr>
        </div>
    </div>
</template>

<style>
.cover .plyr__poster {
    background-size: cover;
}
.plyr__controls {
    opacity: 0;
}
.controls .plyr__controls {
    opacity: 1;
}
</style>
